import type { FaireProductEntity } from "../../entity_types/product";

export const p_j63pst3br2: FaireProductEntity = {
  token: "p_j63pst3br2",
  type: "product",
  name: "Eczema Relief Salve",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8601e1f434658c3681be09bd73492c7b132437005699d4878d2ed09b4d348876.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.09,
  description:
    "Nourishing sweet almond oil slow infused with our homegrown organic calendula, wildcrafted violet leaf & plantain providing powerful relief from itching and scaling of eczema, psoriasis or other dry skin conditions. Tamanu & neem oils offer ant-inflammatory benefits while encouraging healing. This is a top seller in our shop, our customers have great results with it. \n2 oz. Glass Jar",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:52.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
